'use client';

import { useAuthInfo } from '@/hooks/useAuthInfo';
import { LazyMotion, domAnimation } from 'framer-motion';

export default function Template({ children }: { children: React.ReactNode }) {
  useAuthInfo();
  // CSS fade, not a framer `initial={{ opacity: 0 }}`: framer server-renders
  // that as inline opacity:0 and only lifts it from a client effect, so a
  // hydration that never ran the animation left the whole page invisible.
  // LazyMotion stays: every `m.*` under the dashboard relies on it.
  return (
    <LazyMotion features={domAnimation} strict>
      <div className="h-full flex items-start justify-center animate-[router-fade_0.3s_cubic-bezier(0.23,1,0.32,1)_both]">
        {children}
      </div>
    </LazyMotion>
  );
}
